import type { GetScheduleServices, ScheduleService } from '@entities/schedules/service/types';
import { createApi } from '@reduxjs/toolkit/query/react';
import { getRtkConfig } from '@shared/config/index';
import { doConvertDataToFormData } from '@shared/helpers/index';
import type { Video } from '@shared/types/common';

// type SearchScheduleServicesParams = {
// page: string;
// tags: string;
// search: string;
// }

const scheduleServiceApi = createApi({
  reducerPath: 'scheduleServiceQueries',
  baseQuery: getRtkConfig('/api/v1/'),
  tagTypes: ['scheduleServices'],
  keepUnusedDataFor: Number.MAX_SAFE_INTEGER,
  endpoints: (build) => ({
    getScheduleServices: build.query<GetScheduleServices, undefined>({
      query: (params) => ({
        url: `schedules/scheduleservice`,
        params,
      }),

      // serializeQueryArgs: ({ endpointName }) => {
      // 	return endpointName;
      // },
      //
      // merge: (currentCache, newItems, otherArgs) => {
      // 	// Если страница равна единице или в новых специалистах есть с таким же айди, то обновить весь список
      // 	if (
      // 		otherArgs?.arg?.page === '1'
      // 		|| newItems.results.some(с => с.id === currentCache.results[0].id)
      // 	) {
      // 		return newItems;
      // 	} else {
      // 		currentCache.results.push(...newItems.results);
      // 	}
      // },
      //
      // forceRefetch({ currentArg, previousArg }) {
      // 	return currentArg !== previousArg;
      // },

      providesTags: ['scheduleServices'],
    }),

    createScheduleService: build.mutation<Response, Partial<ScheduleService>>({
      // createScheduleService: build.mutation<Response, FormData>({
      query: (data) => {
        return {
          url: 'schedules/scheduleservice/',
          method: 'POST',
          body: doConvertDataToFormData(data),
        };
      },
      invalidatesTags: ['scheduleServices'],
    }),

    getScheduleService: build.query<ScheduleService, { scheduleServiceId?: string }>({
      query: (params) => ({
        // params,
        url: `schedules/scheduleservice/${params.scheduleServiceId}`,
        method: 'GET',
      }),
      providesTags: ['scheduleServices'],
    }),

    updateScheduleService: build.mutation<Response, Partial<ScheduleService>>({
      query: ({ id, ...data }) => ({
        url: `schedules/scheduleservice/${id}/`,
        method: 'PATCH',
        body: {
          ...data,
        },
      }),
      invalidatesTags: ['scheduleServices'],
    }),

    deleteScheduleService: build.mutation<Response, { id: string }>({
      query: ({ id }) => ({
        url: `schedules/scheduleservice/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['scheduleServices'],
    }),
    getScheduleServiceVideo: build.query<Video, { videoId?: number }>({
      query: (params) => ({
        url: `videos/schedule_service_video/${params.videoId}/`,
        method: 'get',
      }),
    }),
  }),
});

export const {
  useGetScheduleServicesQuery,
  useGetScheduleServiceQuery,
  useCreateScheduleServiceMutation,
  useUpdateScheduleServiceMutation,
  useDeleteScheduleServiceMutation,
  useGetScheduleServiceVideoQuery,
} = scheduleServiceApi;

export const scheduleServiceApiReducerPath = scheduleServiceApi.reducerPath;

export const scheduleServiceQueriesReducer = scheduleServiceApi.reducer;

export const scheduleServiceMiddleware = scheduleServiceApi.middleware;
